import { GlobalText } from '../i18n/global-text';

export function intensityConverter(intensity = 1): string {
  const intensityAbsolute = Math.abs(intensity);
  let intensityLevel = GlobalText.beginner;

  if (intensityAbsolute > 3 && intensityAbsolute < 6) {
    intensityLevel = GlobalText.intermediate;
  } else if (intensityAbsolute >= 6) {
    intensityLevel = GlobalText.advanced;
  }

  return intensityLevel;
}
